<template>
  <div>
    <b-modal
      v-model="configModal.show"
      id="modal-1"
      @ok="submit"
      title="Chọn đơn vị cung cấp"
    >
      <el-form
        :model="mData.dataForm"
        :rules="mData.validForm"
        ref="myFormDonViCungCap"
        label-width="100%"
        label-position="top"
      >
        <b-row>
          <b-col md="12">
            <el-form-item
              label="Chọn đơn vị cung cấp"
              prop="don_vi_cung_cap_id"
            >
              <el-select
                placeholder="Chọn đơn vị cung cấp"
                clearable
                v-model="mData.dataForm.don_vi_cung_cap_id"
                filterable
              >
                <el-option
                  v-for="item in mData.danhSachDonViCungCap"
                  :key="item.id"
                  :label="item.du_lieu_khai_bao.user_ten"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </b-modal>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ShareDDATModel from '@/views/admin/ShareModel/ShareDDATModel';
import ShareDichVuModel from '@/views/admin/ShareModel/ShareDichVuModel';
import ShareDonViCungCapModel from '@/views/admin/ShareModel/ShareDonViCungCapModel';
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
export default {
  props: ["configModal", "dataObject"],
  components: {},
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VuiChoiGiaiTri",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataDefault: {
          listProvince: [],
        },
        danhSachDonViCungCap: [],
        dataForm: {
          diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
          don_vi_cung_cap: MethodService.copyObject(ShareDonViCungCapModel.dataForm),
          dich_vu : MethodService.copyObject(ShareDichVuModel.dataForm)
        },
      },
    };
  },
  methods: {
    async load(keyword = "") {
      const res = await DonViCungCapApi.list({
        filters: "loai=ticket&ve_dien_tu.loai=transport_ticket"
      });
      this.mData.danhSachDonViCungCap = res.result;
    },
    async submit(evt) {
      evt.preventDefault();
      this.$refs["myFormDonViCungCap"].validate(async (valid) => {
         if (valid) {
          this.$emit("submit", {
            donViCungCapId: this.mData.dataForm.don_vi_cung_cap_id,
          });
        }
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
